import { pageConfig } from "@/common/service/page-config"
import { get } from "lodash"
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      showPlanDetail: true,
    }
  },
  computed: {
    ...mapGetters(['assignInfo']),
    assignedLicense() {
      return get(this.assignInfo, [pageConfig.oldPlanCode, 'assignLicenseQuantity'], 0);
    },
    licenseTips() {
      if(this.form.selectedNumber < this.assignedLicense) {
        return this.$t('billing.planform.zoom_meeting.less_than_assigned_number_tips_no_br', [
          this.assignedLicense,
          this.assignedLicense - this.form.selectedNumber,
        ]);
      }
      return '';
    },
  },
}
